export const COLOR_NONE = 'none';

export const INDENTATION_WIDTH = 40; // in px
